<template>
  <el-tag
    v-if="stateLabel"
    size="medium"
    :type="cssClass"
    class="margin-left-10"
  >{{ stateLabel }}
  </el-tag>
</template>

<script>
  import dateUtils from "../../../dateUtils";

  export default {
    name: "hc-command-tien-do",
    props: ["deadline", "completeDate", "nextDeadline", "nextDeadline2"],

    data() {
      return {
        deadline_: null,
        nextDeadline_: null,
        nextDeadline2_: null,
        completeDate_: null
      };
    },

    watch: {
      deadline() {
        this.initComponent();
      },

      completeDate() {
        this.initComponent();
      }
    },

    computed: {
      stateLabel() {
        let lastestDeadline = this.deadline_;
        if (this.nextDeadline2_) {
          lastestDeadline = this.nextDeadline2_;
        } else if (this.nextDeadline_) {
          lastestDeadline = this.nextDeadline_;
        }

        if (lastestDeadline > this.completeDate_) {
          return "Trước hạn";
        } else if (lastestDeadline < this.completeDate_) {
          return "Quá hạn";
        } else {
          return "Đúng hạn";
        }
      },

      cssClass() {
        let lastestDeadline = this.deadline_;
        if (this.nextDeadline2_) {
          lastestDeadline = this.nextDeadline2_;
        } else if (this.nextDeadline_) {
          lastestDeadline = this.nextDeadline_;
        }

        if (lastestDeadline > this.completeDate_) {
          return "success";
        } else if (lastestDeadline < this.completeDate_) {
          return "danger";
        } else {
          return "";
        }
      }
    },

    created() {
      this.initComponent();
    },

    methods: {
      initComponent() {
        this.deadline_ = dateUtils.truncDate(this.deadline);
        this.nextDeadline_ = dateUtils.truncDate(this.nextDeadline);
        this.nextDeadline2_ = dateUtils.truncDate(this.nextDeadline2);
        this.completeDate_ = dateUtils.truncDate(this.completeDate);
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-command-tien-do.vue